import "./InviteUser.scss";
import primaryComponents from "../../primaryComponents";
import InviteUserLogic from "./InviteUserLogic";
import InviteValidation from "./InviteUserValidation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InviteUser = ({ closeWidget }) => {
  const {
    setRoleSelected,
    roleSelected,
    inviteDetails,
    setInviteDetails,
    isInviting,
    inviteUser,
    userRoles,
    subAccounts,
    storeList,
  } = InviteUserLogic(closeWidget);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
  } = InviteValidation({ inviteDetails, roleSelected });

  return (
    <div className="invite-user__modal" data-testid="invite-new-user">
      <FontAwesomeIcon
        onClick={closeWidget}
        className="d-block ml-auto"
        icon="times"
        style={{ fontSize: "30px" }}
      />

      <div className="mt-4">
        <h3>Invite New User</h3>
        <p>Invite team members and assign them a role</p>
        <form
          onSubmit={handleSubmit(inviteUser)}
          className="invite-user__modal__form"
        >
          {/* users role */}
          <div className="mb-2">
            <primaryComponents.SelectFieldV2
              label="Role"
              control={control}
              isRequired={true}
              placeholder="Select role"
              name="role"
              value={
                inviteDetails.role === ""
                  ? "Select role..."
                  : inviteDetails.role
              }
              errorMessage={errors.role}
              options={userRoles || []}
              idKey="id"
              nameKey="label"
              onChange={(value) => {
                setRoleSelected(
                  userRoles?.find((item) => item.id === value).label,
                );
                setInviteDetails((prev) => ({
                  ...prev,
                  role: value,
                }));
              }}
            />
          </div>
          {/*  first name */}
          {roleSelected !== "Owner" ? (
            <>
              <div className="mb-2">
                <primaryComponents.InputFieldV2
                  control={control}
                  label="First Name"
                  placeholder="Enter fisrt name"
                  isRequired={true}
                  type="text"
                  className="white"
                  defaultValue={inviteDetails.firstName}
                  name="firstName"
                  errorMessage={errors.firstName}
                  onKeyUp={() =>
                    errors.firstName !== undefined && trigger("firstName")
                  }
                  onChange={({ target: { value } }) => {
                    setInviteDetails((prev) => ({
                      ...prev,
                      firstName: value,
                    }));
                  }}
                  register={register}
                />
              </div>
              <div className="mb-2">
                <primaryComponents.InputFieldV2
                  control={control}
                  label="Last Name"
                  placeholder="Enter last name"
                  isRequired={true}
                  type="text"
                  defaultValue={inviteDetails.lastName}
                  name="lastName"
                  className="white"
                  errorMessage={errors.lastName}
                  onKeyUp={() =>
                    errors.lastName !== undefined && trigger("lastName")
                  }
                  onChange={({ target: { value } }) => {
                    setInviteDetails((prev) => ({
                      ...prev,
                      lastName: value,
                    }));
                  }}
                  register={register}
                />
              </div>
              <div className="mb-2">
                <primaryComponents.PhoneNumberInputFieldV2
                  control={control}
                  label="Phone Number"
                  placeholder="Enter Phone Number"
                  type="number"
                  value={inviteDetails.PhoneNumber}
                  name="phoneNumber"
                  isRequired={true}
                  errorMessage={errors.phoneNumber}
                  onChange={({ target: { value } }) => {
                    setInviteDetails((prev) => ({
                      ...prev,
                      PhoneNumber: value,
                    }));
                  }}
                  register={register}
                  phoneCodeEditable={true}
                  onChangePhoneCode={(val) =>
                    setInviteDetails((prev) => ({
                      ...prev,
                      PhoneCode: val,
                    }))
                  }
                />
              </div>
            </>
          ) : null}

          {/* email address */}
          <div>
            <primaryComponents.InputFieldV2
              control={control}
              label="Email Address"
              placeholder="Enter email address of team member"
              isRequired={roleSelected !== "Owner" ? true : false}
              type="email"
              defaultValue={inviteDetails.email}
              name="email"
              errorMessage={errors.email}
              onKeyUp={() => errors.email !== undefined && trigger("email")}
              onChange={({ target: { value } }) => {
                setInviteDetails((prev) => ({
                  ...prev,
                  email: value,
                }));
              }}
              register={register}
              className="white"
            />
          </div>

          {/* user sub accounts */}
          <div className="mt-2 mb-2">
            <primaryComponents.MultipleSelectFieldV2
              label="Assign Subaccounts"
              control={control}
              defaultValue={inviteDetails.businessId}
              isRequired={true}
              placeholder="Select subaccount"
              name="businessId"
              errorMessage={errors.businessId}
              options={subAccounts}
              idKey="id"
              nameKey="tag"
              onChange={(values) => {
                let newValues = [];
                values?.forEach((item) => {
                  newValues.push(item.value);
                });
                setInviteDetails((prev) => ({
                  ...prev,
                  businessId: newValues,
                }));
              }}
            />
          </div>

          <div className="mb-2">
            <primaryComponents.MultipleSelectFieldV2
              label="Assign store"
              control={control}
              defaultValue={inviteDetails.storeId}
              isRequired={true}
              placeholder="Select store"
              name="storeId"
              errorMessage={errors.storeId}
              options={storeList}
              idKey="id"
              nameKey="name"
              onChange={(values) => {
                let newValues = [];
                values?.forEach((item) => {
                  newValues.push(String(item.value));
                });
                setInviteDetails((prev) => ({
                  ...prev,
                  storeId: newValues,
                }));
              }}
            />
          </div>

          {/* TODO: display sub-account list here... */}
          <div className="invite-user__modal__actions">
            {/* Invite button */}
            <primaryComponents.Button
              classNames={"btn btn--primary btnInvite"}
              isLoading={isInviting}
              isDisabled={isInviting || roleSelected === "Owner"}
              loadingText="Inviting..."
              type="submit"
            >
              Invite new user
            </primaryComponents.Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteUser;
